import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import { formatTimeToRead } from "./knowledgebase-utils"
import styles from "./knowledgebase-post-card.module.scss"

export default ({ post }) => {
  const lead = false
  
  return (<div className={styles.post}>
    <Link className={styles.link} to={post.path}>
      <div className={styles.image}>
        {post.mark && <div className={styles.mark}>{post.mark}</div>}
        {post.imageMob && <Img fluid={post.imageMob}
          objectFit="cover"
          objectPosition="50% 50%"
          alt={""} />}
      </div>
      <div className={styles.info}>
        <div>
          <div className={styles.time}>{formatTimeToRead(post.timeToRead)}</div>
          <div className={styles.title}>{post.title}</div>
        </div>
        <div className={styles.details}><span>Подробнее</span></div>
      </div>
    </Link>
  </div>
  )
}